import _, { get } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';
import { withComponentId } from '../../../common/ComponentIdContext';
import { withComponentName } from '../../../common/ComponentNameContext';
import { TYPE_DISABLE } from '../../../common/sync-component/Const';
import { getColorRedGreen } from '../../../helpers/Color';
import {
  getDefaultSyncType,
  syncComponentSelector,
} from '../../../helpers/Common';
import EventEmitter, {
  SYNC_COMPONENT_SEARCH,
} from '../../../helpers/EventEmitter';
import { formatPrice, formatTextFloat } from '../../../helpers/Text';
import Table from '../../../common/table/Table';
import CellHover from '../../watchlist/summary/CellHover';
import TextBlink from '../../../common/table/TextBlink';
import TradingViewUrl from '../../../common/TradingViewUrl';

const schema = (listColumn, i18nTitleKey) =>
  Object.keys(listColumn).map((item, index) => {
    const key = listColumn[item];
    const title = `${i18nTitleKey}.${item}`;

    const result = {
      key,
      title,
    };

    if (index === 0) {
      return {
        ...result,
        isString: true,
        render: (text, item) => (
          <CellHover organCode={item.organCode} isShowDeleteIcon={false}>
            <TextBlink item={item} tradingDate="tradingDate">
              <TradingViewUrl code={item.organCode} />
              &nbsp;{text}
            </TextBlink>
          </CellHover>
        ),
      };
    }

    if (_.includes([listColumn.PRICE], key)) {
      return {
        ...result,
        render: (text, item) => {
          return (
            <TextBlink item={item} tradingDate="tradingDate">
              {formatTextFloat(formatPrice(text))}
            </TextBlink>
          );
        },
      };
    }

    if (_.includes([listColumn.PERCENT_PRICE_CHANGE_1DAY], key)) {
      return {
        ...result,
        render: (text, item) => {
          return (
            <TextBlink
              item={item}
              tradingDate="tradingDate"
              className={getColorRedGreen(text, 'text')}
            >
              {formatTextFloat(text * 100)}%
            </TextBlink>
          );
        },
      };
    }

    return {
      ...result,
      render: text => {
        return (
          <TextBlink item={item} tradingDate="tradingDate">
            <span className={getColorRedGreen(text, 'text')}>
              {formatTextFloat(text * 100)} %
            </span>
          </TextBlink>
        );
      },
    };
  });

class TablePerformance extends React.PureComponent {
  onRowClick = organCode => {
    const { listOrganizationByOrganCode, syncType } = this.props;
    if (syncType === TYPE_DISABLE) {
      return;
    }
    EventEmitter.dispatch(SYNC_COMPONENT_SEARCH, {
      syncType: syncType,
      search: listOrganizationByOrganCode[organCode],
    });
  };

  render() {
    const {
      listId,
      getDataFromRedux,
      listColumns,
      resizable,
      columnDraggable,
      rowDraggable,
      i18nTitleKey,
      isLoading,
      sortState,
      onSort,
    } = this.props;

    return (
      <Table
        clickRow={this.onRowClick}
        sortState={sortState}
        onSort={onSort}
        thValign="top"
        isLoading={isLoading}
        ids={listId}
        resizable={resizable}
        columnDraggable={columnDraggable}
        rowDraggable={rowDraggable}
        getDataFromRedux={getDataFromRedux}
        schema={schema(listColumns, i18nTitleKey)}
      />
    );
  }
}

const mapStateToProps = (state, { componentName, componentId }) => {
  return {
    listOrganizationByOrganCode:
      state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
    syncType: syncComponentSelector(state, componentName, componentId),
  };
};

export default compose(
  withComponentId,
  withComponentName,
  connect(mapStateToProps),
)(TablePerformance);
